import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getProvinceByAbbr } from "@talladega/types";
import purchaseQueryKeys from "../purchaseQueryKeys";

type UpdateIcoDetailsRequest = {
  dealId: string | null;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  latitude: number | null;
  longitude: number | null;
};

const postUpdateIcoDetails = async (req: UpdateIcoDetailsRequest) => {
  return api.rawPut(`api/purchases/${req.dealId}/ico/details`, {
    json: {
      ...req,
      provinceId: getProvinceByAbbr(req.province)?.id,
    },
  });
};

export default function useUpdateIcoDetailsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postUpdateIcoDetails,
    onSuccess: (_, { dealId }) => {
      if (!dealId) return;
      queryClient.invalidateQueries({
        queryKey: purchaseQueryKeys.purchases([dealId]),
      });
    },
  });
}
